export const FounderIcon = (props) => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="13" r="12" fill="#E8D17E" />
      <circle
        cx="12"
        cy="13"
        r="10"
        fill="url(#paint0_linear_1_1322)"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M15.7313 8.088C15.6939 8.48933 15.6659 8.87667 15.6473 9.25C15.6379 9.62333 15.6333 9.908 15.6333 10.104C15.6333 10.3187 15.6379 10.5193 15.6473 10.706C15.6566 10.8927 15.6659 11.056 15.6753 11.196H15.3533C15.2506 10.496 15.1106 9.94533 14.9333 9.544C14.7559 9.13333 14.5179 8.844 14.2193 8.676C13.9206 8.49867 13.5239 8.41 13.0293 8.41H12.4273C12.1473 8.41 11.9326 8.43333 11.7833 8.48C11.6339 8.52667 11.5313 8.62467 11.4753 8.774C11.4286 8.92333 11.4053 9.152 11.4053 9.46V16.46C11.4053 16.8147 11.4426 17.0807 11.5173 17.258C11.5919 17.4353 11.7366 17.552 11.9513 17.608C12.1659 17.664 12.4739 17.6967 12.8753 17.706V18C12.6046 17.9813 12.2546 17.972 11.8253 17.972C11.3959 17.9627 10.9526 17.958 10.4953 17.958C10.1033 17.958 9.72527 17.9627 9.36127 17.972C8.99727 17.972 8.67994 17.9813 8.40927 18V17.72C8.71727 17.7013 8.94594 17.664 9.09527 17.608C9.25394 17.552 9.35661 17.44 9.40327 17.272C9.45927 17.104 9.48727 16.852 9.48727 16.516V9.572C9.48727 9.22667 9.45927 8.97467 9.40327 8.816C9.35661 8.648 9.25394 8.536 9.09527 8.48C8.94594 8.41467 8.71727 8.37733 8.40927 8.368V8.088C8.78261 8.09733 9.17461 8.10667 9.58527 8.116C10.0053 8.116 10.4159 8.12067 10.8173 8.13C11.2279 8.13 11.6059 8.13 11.9513 8.13C12.3059 8.13 12.5906 8.13 12.8053 8.13C13.2346 8.13 13.7199 8.13 14.2613 8.13C14.8119 8.12067 15.3019 8.10667 15.7313 8.088ZM13.6173 12.96C13.6173 12.96 13.6173 13.0067 13.6173 13.1C13.6173 13.1933 13.6173 13.24 13.6173 13.24H10.9853C10.9853 13.24 10.9853 13.1933 10.9853 13.1C10.9853 13.0067 10.9853 12.96 10.9853 12.96H13.6173ZM13.9393 11.112C13.9019 11.644 13.8833 12.05 13.8833 12.33C13.8926 12.61 13.8973 12.8667 13.8973 13.1C13.8973 13.3333 13.9019 13.59 13.9113 13.87C13.9206 14.15 13.9439 14.556 13.9813 15.088H13.6593C13.6219 14.7707 13.5519 14.472 13.4493 14.192C13.3466 13.9027 13.1879 13.674 12.9733 13.506C12.7679 13.3287 12.4693 13.24 12.0773 13.24V12.96C12.3666 12.96 12.6046 12.8993 12.7913 12.778C12.9779 12.6567 13.1226 12.5027 13.2253 12.316C13.3373 12.12 13.4213 11.9193 13.4773 11.714C13.5426 11.4993 13.5893 11.2987 13.6173 11.112H13.9393Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_1322"
          x1="12"
          y1="2"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.322917" stopColor="#E8D17E" />
          <stop offset="1" stopColor="#9F8E5A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
